import { isMobile } from 'react-device-detect'

import { copyToClipboard } from '../utils'

import { ItListAnalyticsProps, useAnalytics } from './analytics/useAnalytics'

export type ShareableData = ShareData | string

type UseShareReturn = (
  url: string,
  trackingData?: ItListAnalyticsProps,
  clipboardOnly?: boolean
) => Promise<void>

/**
 * Will let you share either through the navigator's API or through a clipboard content.
 * @returns
 */
export default function useShare(): UseShareReturn {
  const { track } = useAnalytics()
  return async (url, trackingData, clipboardOnly = false) => {
    if (url === null) {
      throw new Error('This content cannot be shared at the moment')
    }
    trackingData &&
      track({ eventName: 'ItList Share Clicked', props: trackingData })

    if (!clipboardOnly && isMobile && navigator.canShare) {
      navigator.share({ url })
    } else {
      await copyToClipboard(url, 'Link copied to clipboard!')
    }
  }
}
